export default __webpack_public_path__ + "static/media/gh1.f5a8af22.jpg";